import React from "react";
import BusTicketScreen from "../../../common/AllTickets/BusTicketScreen";

const SuperBusTicket = () => {
  return <BusTicketScreen mode="admin" />;
};
export default SuperBusTicket;
